// Module
var code = `<div class="spg-boolean-switch" role="checkbox" data-bind="click: function() { question.value = !question.value; }, attr: {id: question.inputId, 'aria-required': question.ariaRequired, 'aria-label': question.ariaLabel, 'aria-invalid': question.ariaInvalid, 'aria-errormessage': question.ariaErrormessage}">
  <div class="spg-boolean-switch__button" tabindex="0" data-bind="key2click, css: { 'spg-boolean-switch__button--checked': question.koValue }">
    <div class="spg-boolean-switch__thumb">
      <div class="spg-boolean-switch__thumb-circle spg-boolean-switch__thumb--left"></div>
    </div>
    <div class="spg-boolean-switch__thumb">
      <div class="spg-boolean-switch__thumb-circle spg-boolean-switch__thumb--right"></div>
    </div>
  </div>
  <div class="spg-boolean-switch__caption">
    <div class="spg-boolean-switch__title">
      <!-- ko template: { name: 'survey-string', data: question.locTitle } --><!-- /ko -->
    </div>
  </div>
</div>`;
// Exports
export default code;